module.exports = __webpack_public_path__ + "img/app-header-alarm-on.9f52c7a6.svg";